<!-- 模板编辑填写 -->
<template>
    <div class="templateEdit">
        <el-row style="background-color: white;position: fixed;padding: 10px;top: 70px;right: 50px;z-index: 100;width: calc(100% - 400px);text-align: center;" v-if="toolShow && !$isEmpty(htmlInfo) && templateType == 2">
            <template v-if="dataInfo.studentTemplateExamineStatus == 3">
                <el-button style="color: red;font-weight: bold;" @click="seeRemark">审核未通过【查看原因】</el-button>
            </template>
            <template v-if="dataInfo.studentTemplateExamineStatus != 1">
                <el-button class="but" type="primary" v-if="showInfo.edit && currentType == 1 && isEdit" @click="editNow" plain icon="el-icon-edit">编辑</el-button>
            </template>
            <template v-if="templateName =='入学登记表' && $strExistHostnameOnce(['localhost','hbsi'])">

            </template>
            <template v-else>
                <el-button class="but" type="primary" v-if="showInfo.print && currentType == 1" @click="printNow" plain icon="el-icon-printer">打印</el-button>
                <el-button class="but" type="primary" v-if="showInfo.down && currentType == 1" @click="downloadNow" plain icon="el-icon-download">导出</el-button>
            </template>
            <el-button class="but" type="primary" v-if="currentType == 2" @click="getInfo" plain icon="el-icon-view">预览</el-button>
            <template v-for="(item,index) in signList">
                <el-button :key="index" class="but" type="primary" v-if="showInfo.save && currentType == 2" @click="singShow(item)" plain icon="el-icon-edit">本人签名</el-button>
            </template>
            <el-button class="but" type="primary" v-if="showInfo.save && currentType == 2" @click="saveInfo" plain icon="el-icon-suitcase">保存</el-button>
        </el-row>
        <el-row style="text-align:right;" v-if="toolShow && templateType == 1">
            <el-button class="but" type="primary" v-if="showInfo.print && currentType == 1 && !this.$strExistHostnameOnce(['jlaudev'])" @click="printNowImg" plain icon="el-icon-printer">打印</el-button>
            <el-button class="but" type="primary" v-if="showInfo.down && currentType == 1" @click="downImg" plain icon="el-icon-download">下载</el-button>
        </el-row>
        <template v-if="templateType == 1">
            <el-row style="max-width: 800px;text-align: center;margin: 0 auto;">
                <div id='printBill_img'>
                    <div v-for='(item,index) in imgUrlList' :key="index+'imgUrlList'">
                        <img width="100%" :src="$isHttp(item)" alt="" style="vertical-align:top">
                        <div style="page-break-after:always;"></div>
                    </div>
                </div>
            </el-row>
        </template>
        <template v-if="templateType == 2">
            <div style="margin: 0 auto;width: 1060px;height: auto;margin-bottom: 300px;">
                <div id='printBill' ref="printContent" v-html="htmlInfo">

                </div>
            </div>
        </template>
        <el-dialog title="签名方式" :visible.sync="visible" width="800px" >
            <div style="text-align: center;padding-bottom: 50px;">
                <el-button type="primary" @click="signStart" plain icon="el-icon-monitor">电脑鼠标签名</el-button>
                <el-button type="primary" @click="creatQRCode" plain icon="el-icon-mobile-phone">手机扫码签名</el-button>
            </div>
        </el-dialog>

        <el-dialog title="" :visible.sync="visible_qRcode" width="300px" :close-on-click-modal="false">
            <div style="text-align: center;padding-bottom: 20px;">
                <p style="font-size: 12px;margin-top: 0;">请打开手机浏览器扫描下方二维码进行签名</p>
                <img :src="qRcodeImg" style="height: 200px;width: 200px;" />
                <el-button type="primary" :loading="signLoading" @click="getSignInfo" icon="el-icon-mobile-phone">我已签名，获取我的签名</el-button>
            </div>
        </el-dialog>
        <!-- 签名 -->
        <singDiv v-if="visible_sign" :visible="visible_sign" :attribute-id="onAttributeId" @closeMsg="closeMsg" @signValue="saveSignValue"></singDiv>

        <!-- 编辑表格对话框 -->
        <el-dialog title="编辑表格" :visible.sync="visible_editDialog" width="800px" :close-on-click-modal="false" @opened="handleDialogOpened">
            <el-form ref="editForm" :model="editFormData" label-width="120px">
                <el-form-item
                    v-for="(item, index) in openAttributeInfoList"
                    v-if="item && !$isEmpty(item.attributeName)"
                    :key="'attr_' + item.attributeId + '_' + index"
                    :rules="getFormRules(item)"
                    :prop="'attr_' + item.attributeId">
                    <span slot="label">
                        {{ item.attributeName }}
                        <!-- <span v-if="item.notNullStatus == 1" style="color: red;">*</span> -->
                    </span>
                    <!-- 1: 单选 -->
                    <el-select
                        v-if="item.inputType == 1"
                        v-model="editFormData['attr_' + item.attributeId]"
                        :placeholder="item.desc || '请选择' + item.attributeName"
                        style="width: 100%;">
                        <el-option
                            v-for="(val, idx) in getAttributeValues(item)"
                            :key="idx"
                            :label="val"
                            :value="val">
                        </el-option>
                    </el-select>
                    <!-- 2: 多选 -->
                    <el-checkbox-group
                        v-else-if="item.inputType == 2"
                        v-model="editFormData['attr_' + item.attributeId]">
                        <el-checkbox
                            v-for="(val, idx) in getAttributeValues(item)"
                            :key="idx"
                            :label="val">
                            {{ val }}
                        </el-checkbox>
                    </el-checkbox-group>
                    <!-- 3: 输入 -->
                    <el-input
                        v-else-if="item.inputType == 3"
                        v-model="editFormData['attr_' + item.attributeId]"
                        :placeholder="item.desc || '请输入' + item.attributeName"
                        :minlength="getLimitCondition(item).minNumber"
                        :maxlength="getLimitCondition(item).maxNumber">
                    </el-input>
                    <!-- 4: 多级联动 -->
                    <div v-else-if="item.inputType == 4" :id="'cascade_' + item.attributeId">
                        <!-- 多级联动需要异步加载，这里先显示加载中 -->
                        <span>加载中...</span>
                    </div>
                    <!-- 5: 上传图片 -->
                    <el-upload
                        v-else-if="item.inputType == 5"
                        class="avatar-uploader"
                        :action="uploadUrl"
                        :headers="getUploadHeaders()"
                        :show-file-list="false"
                        :on-success="(res, file) => handleUploadSuccess(res, file, item.attributeId)"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="editFormData['attr_' + item.attributeId]" :src="$isHttp(editFormData['attr_' + item.attributeId])" class="avatar" style="max-width: 200px; max-height: 200px;">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <!-- 6: 上传附件 -->
                    <el-upload
                        v-else-if="item.inputType == 6"
                        class="upload-demo"
                        :action="uploadUrl"
                        :headers="getUploadHeaders()"
                        :on-success="(res, file) => handleUploadSuccess(res, file, item.attributeId)"
                        :on-remove="(file, fileList) => handleFileRemove(item.attributeId, file, fileList)"
                        :before-upload="beforeAvatarUpload"
                        :file-list="fileListMap[item.attributeId] || []">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <!-- 7: 多行输入 -->
                    <el-input
                        v-else-if="item.inputType == 7"
                        type="textarea"
                        v-model="editFormData['attr_' + item.attributeId]"
                        :placeholder="item.desc || '请输入' + item.attributeName"
                        :minlength="getLimitCondition(item).minNumber"
                        :maxlength="getLimitCondition(item).maxNumber || 400"
                        :rows="4">
                    </el-input>
                    <!-- 8: 日期 -->
                    <el-date-picker
                        v-else-if="item.inputType == 8"
                        v-model="editFormData['attr_' + item.attributeId]"
                        type="date"
                        :placeholder="item.desc || '请选择' + item.attributeName"
                        value-format="yyyy-MM-dd"
                        style="width: 100%;">
                    </el-date-picker>
                    <!-- 9: 签名 -->
                    <div v-else-if="item.inputType == 9">
                        <div v-if="editFormData['attr_' + item.attributeId]" v-html="editFormData['attr_' + item.attributeId]" style="margin-bottom: 10px;"></div>
                        <el-button type="primary" @click="singShow({attributeId: item.attributeId})" plain icon="el-icon-edit">本人签名</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible_editDialog = false">取消</el-button>
                <el-button type="primary" @click="handleEditDialogConfirm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {getStorageKeyForRoleTag,getCookieForRoleTag} from "../common/ulit";
import jQuery, { data } from 'jquery';
import store from "@/store/index";
import dateTime from '../static/date/dateTime.min.js' //注意路径
import html2canvas from 'html2canvas';
import printJS from 'print-js';
import jquery from "jquery";
import singDiv from "@/components/singDiv"; //签名
export default {
    name: 'TemplateEdit',
    components: {
        singDiv
    },
    props: {
        templateName: { //模板名称
            type: String,
            default: ""
        },
        toolShow:{ //是否显示头部工具栏
            type: Boolean,
            default: false
        },
        showInfo:{ //按钮功能是否显示
            type: Object,
            default: function () {
                return {
                    edit:true,
                    print:true,
                    down:true,
                    save:true,
                }
            }
        }
    },
    data() {
        return {
            uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
            studentInfo:{},//学生信息
            htmlInfo:null, //表格信息html
            attributeList:{}, //属性map,
            templateId:null, //模板ID
            allInputType4:{}, //用于存所有联动数据，格式{attributeId:[]}
            getParamKey:{}, //用于获取填写数据 格式{属性ID:类型}
            currentType:1, // 1:预览 2:编辑
            isEdit:false, //是否能够编辑 1：可预览 2：可预览可编辑可编辑
            templateType:null,//1:图片 2：表格
            imgUrlList:[], //图片类型List
            downloadUrl:"", //新的下载地址
            dataInfo:{},
            signList:[],

            visible:false, //选择签名方式
            visible_sign:false, //显示PC签名
            onAttributeId:"",
            visible_qRcode:false,
            qRcodeImg:"",
            signLoading:false,
            htmlInfoNew:null, //表格信息html
            openAttributeInfoList:[],
            visible_editDialog:false, //编辑对话框显示
            editFormData:{}, //弹窗表单数据
            fileListMap:{} //存储每个属性ID对应的文件列表，避免跳动
        }
    },
    created() {
        this.studentInfo = JSON.parse(sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag()));
        this.getTemplateByName();
    },
    methods:{
        editNow(){  //编辑
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            console.log("进入编辑")
            this.attributeList = {}; //属性map,
            this.$store.dispatch("user/getCanEditTemplateSingle",{templateName:this.templateName}).then((ret) => {
                loading.close();
                if(ret.code == 0){
                    this.currentType = 2;
                    if(!this.$strExistHostnameOnce(['hevttc','localhost1'])){ //指定某个学校进入弹窗编辑模式
                        this.htmlInfo = ret.data.templateHtml; //表格信息html
                    }else{
                        this.htmlInfoNew = ret.data.templateHtml;
                    }
                    //attributeList是数组，转换成自己想要的map类型
                    if(!this.$isEmpty(ret.data.attributeList) && ret.data.attributeList.length > 0){
                        for(let index in ret.data.attributeList){
                            this.attributeList[ret.data.attributeList[index].attributeName] = ret.data.attributeList[index]; //属性map,
                        }
                    }
                    this.templateId = ret.data.templateId; //模板ID

                    this.setShowValue();
                }else{
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
                loading.close();
            });
        },
        setShowValue(){ //将html中的可填写数据转换成相应的下拉或者填写框
            //inputType：1单选 2多选 3输入 4多级联动  5上传图片 6上传附件 7多行输入 8日期 9签名
            if(this.$strExistHostnameOnce(['hevttc','localhost1'])){ //指定某个学校进入弹窗编辑模式
                //获取所有{}中的数据
                var regex3 = /\{(.+?)\}/g;  // {} 花括号，大括号
                let editArray = this.htmlInfoNew.match(regex3); //{}中的数据数组
                this.openAttributeInfoList = [];
                let attributeIdSet = new Set(); // 用于去重，确保每个attributeId只出现一次
                for(let i in editArray){
                    let one = editArray[i].indexOf(".");
                    let two = editArray[i].indexOf("@");
                    let attributeName = editArray[i].slice(one + 1,two); //截取字符串，获取属性名称
                    //根据属性名获取相应的属性数据，判断属于什么编辑类型
                    let attributeInfo = this.attributeList[attributeName];
                    if(attributeInfo && !this.$isEmpty(attributeInfo.attributeId)){
                        // 检查是否已经添加过这个attributeId，避免重复
                        if(!attributeIdSet.has(attributeInfo.attributeId)){
                            attributeIdSet.add(attributeInfo.attributeId);
                            this.openAttributeInfoList.push(attributeInfo); //属性数据
                        }
                    }
                }

                // 如果是指定学校，弹出编辑对话框
                if(this.$strExistHostnameOnce(['hevttc','localhost1'])){
                    this.visible_editDialog = true;
                    // 初始化表单数据
                    this.initEditFormData();
                }
            }else{
                //获取所有{}中的数据
                var regex3 = /\{(.+?)\}/g;  // {} 花括号，大括号
                let editArray = this.htmlInfo.match(regex3); //{}中的数据数组
                this.signList = [];
                for(let i in editArray){
                    let one = editArray[i].indexOf(".");
                    let two = editArray[i].indexOf("@");
                    let attributeName = editArray[i].slice(one + 1,two); //截取字符串，获取属性名称
                    //根据属性名获取相应的属性数据，判断属于什么编辑类型
                    let attributeInfo = this.attributeList[attributeName]; //属性数据
                    if(this.$isEmpty(attributeInfo)){
                        continue;
                    }
                    this.getParamKey[attributeInfo.attributeId] = attributeInfo.inputType; //用于获取填写数据
                    if(attributeInfo.inputType == 1){ //单选类型
                        let htm = "<option value=''>请选择</option>";
                        let vList = attributeInfo.attributeValues.replace(/\r/g,"").split("\n");
                        for(let inx in vList){
                            if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value) && attributeInfo.attributeRelation.value == vList[inx]){
                                htm += "<option selected value='"+vList[inx]+"'>"+vList[inx]+"</option>";
                            }else{
                                htm += "<option value='"+vList[inx]+"'>"+vList[inx]+"</option>";
                            }
                        }
                        htm = "<div class='select'><select class='attrEditInfo1' notNullStatus='"+attributeInfo.notNullStatus+"' name='"+attributeInfo.attributeId+"' title='请选择"+attributeName+"' placeholder='"+(attributeInfo.desc || "请选择"+attributeName)+"' >"+htm+"</select></div>";
                        this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                    }else if(attributeInfo.inputType == 2){ //多选类型
                        let htm = "";
                        let vList = attributeInfo.attributeValues.replace(/\r/g,"").split("\n");
                        let relationVal = "";
                        if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                            relationVal = attributeInfo.attributeRelation.value; //选中的值，分割
                        }
                        for(let inx in vList){
                            if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value) && (','+relationVal+',').indexOf(','+vList[inx]+',') >= 0){
                                htm += "<span class='checkboxClass'><input class='attrEditInfo2' title='请选择"+attributeName+"' placeholder='"+(attributeInfo.desc || "请选择"+attributeName)+"' notNullStatus='"+attributeInfo.notNullStatus+"'  type='checkbox' checked value='"+vList[inx]+"' name='"+attributeInfo.attributeId+"' id='che_"+attributeInfo.attributeId+'_'+inx+"' /><label for='che_"+attributeInfo.attributeId+'_'+inx+"'>"+vList[inx]+"</label></span>";
                            }else{
                                htm += "<span class='checkboxClass'><input class='attrEditInfo2' title='请选择"+attributeName+"' placeholder='"+(attributeInfo.desc || "请选择"+attributeName)+"' notNullStatus='"+attributeInfo.notNullStatus+"'  type='checkbox' value='"+vList[inx]+"' name='"+attributeInfo.attributeId+"' id='che_"+attributeInfo.attributeId+'_'+inx+"' /><label for='che_"+attributeInfo.attributeId+'_'+inx+"'>"+vList[inx]+"</label></span>";
                            }
                        }
                        this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                    }else if(attributeInfo.inputType == 3){ //输入类型
                        let htm = "";
                        let limitCondition = {minNumber:null,maxNumber:null};
                        if(attributeInfo.limitCondition != null && attributeInfo.limitCondition != ""){
                            limitCondition = JSON.parse(attributeInfo.limitCondition);
                            if(limitCondition.minNumber == 0){
                                limitCondition.minNumber = null;
                            }
                            if(limitCondition.maxNumber == 0){
                                limitCondition.minNumber = null;
                            }
                        }
                        if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                            htm = "<input class='attrEditInfo3 inputClass' minlength='"+limitCondition.minNumber+"' maxlength='"+limitCondition.maxNumber+"' notNullStatus='"+attributeInfo.notNullStatus+"' title='请输入"+attributeName+"' placeholder='"+(attributeInfo.desc || "请输入"+attributeName)+"' name='"+attributeInfo.attributeId+"' value='"+attributeInfo.attributeRelation.value+"' />";
                        }else{
                            htm = "<input class='attrEditInfo3 inputClass' minlength='"+limitCondition.minNumber+"' maxlength='"+limitCondition.maxNumber+"' notNullStatus='"+attributeInfo.notNullStatus+"' title='请输入"+attributeName+"' placeholder='"+(attributeInfo.desc || "请输入"+attributeName)+"' name='"+attributeInfo.attributeId+"' />";
                        }
                        this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                    }else if(attributeInfo.inputType == 4){ //多级联动类型
                        let htm = "";
                        let relationVal = "";
                        if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                            relationVal = attributeInfo.attributeRelation.value; //选中的字|||分割
                        }
                        // let relationVal = "广东省|||深圳市"; //选中的字|||分割
                        this.$store.dispatch("user/getAttrTreeById",{attributeId:attributeInfo.attributeId}).then((ret) => {
                            if(ret.code == 0){
                                this.allInputType4[attributeInfo.attributeId] = ret.data.children;
                                if(!this.$isEmpty(ret.data) && !this.$isEmpty(ret.data.children)){
                                    let chList = ret.data.children;
                                    // for(let j in chList){
                                    //     this.allInputType4[attributeInfo.attributeId][chList[j].attributeName] = chList[j];
                                    // }
                                    htm += this.getErgodicInfo(chList,relationVal,attributeInfo.attributeId,"",editArray[i]);
                                    // htm += this.getErgodicInfo(chList,null,attributeInfo.attributeId,"",editArray[i]);
                                }
                            }else{
                                this.$message.error(ret.msg);
                                this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                            }
                        }).catch((err) => {
                            this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                        });
                    }else if(attributeInfo.inputType == 5){ //上传图片
                        let htm = "";
                        if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                            htm = "<img class='img"+attributeInfo.attributeId+"' style='width: 90%;height: auto;margin:0 auto;display:block;' src='"+this.$isHttp(attributeInfo.attributeRelation.value)+"' />";
                            htm += '<div class="attributeInfoImg attributeInfoImg'+attributeInfo.attributeId+'" style="display:none;"><label title="上传'+attributeInfo.attributeName+'" class="lee-upload-fileicon l-icon-upload-big" for="fileId'+attributeInfo.attributeId+'">'+
                            '<i class="el-icon-circle-plus-outline" style=""></i><br/>上传图片'+
                            '</label><input type="file" id="fileId'+attributeInfo.attributeId+'" class="avatar-input">'+
                            '<input type="hidden" name="'+attributeInfo.attributeId+'" value="'+attributeInfo.attributeRelation.value+'"></div>';
                            setTimeout(function(){
                                var setNull = null;
                                jQuery('.img'+attributeInfo.attributeId).hover(function(){
                                    if(setNull != null){
                                       clearTimeout(setNull);
                                    }
                                    jQuery('.attributeInfoImg'+attributeInfo.attributeId).show();
                                },function(){
                                    setNull = setTimeout(function(){
                                        jQuery('.attributeInfoImg'+attributeInfo.attributeId).hide();
                                    },1000);
                                });
                                jQuery('.attributeInfoImg'+attributeInfo.attributeId).hover(function(){
                                    clearTimeout(setNull);
                                },function(){
                                    setNull = setTimeout(function(){
                                        jQuery('.attributeInfoImg'+attributeInfo.attributeId).hide();
                                    },1000);
                                },1000);
                            },1000);
                        }else{
                            htm = '<div class="attributeInfoImg"><label title="上传'+attributeInfo.attributeName+'" class="lee-upload-fileicon l-icon-upload-big" for="fileId'+attributeInfo.attributeId+'">'+
                            '<i class="el-icon-circle-plus-outline" style=""></i><br/>上传图片'+
                            '</label><input type="file" id="fileId'+attributeInfo.attributeId+'" class="avatar-input">'+
                            '<input type="hidden" name="'+attributeInfo.attributeId+'"><div>';
                        }
                        this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);

                        //延时绑定 上传
                        var this_ = this;
                        setTimeout(function(){
                            jQuery(".attributeInfoImg").parent().css("position","relative");
                            jQuery("#fileId"+attributeInfo.attributeId).change(function(){
                                var fd = new FormData(),this1_ = this,
                                attributeId = jQuery(this1_).attr("id").replace("fileId","");
                                // 将用户选择的文件，添加到 FormData 中
                                fd.append('file', this.files[0])
                                var xhr = new XMLHttpRequest();
                                let token = this_.$getCookieForRoleTag();
                                xhr.open('POST', this_.uploadUrl);
                                xhr.setRequestHeader('token', token);
                                xhr.onload = function () {
                                    if(xhr.status === 200){ //成功！
                                        let ret = JSON.parse(xhr.response); //返回值
                                        if(ret.code == 0){
                                            jQuery("input[name='"+attributeId+"']").val(ret.data.url);
                                            jQuery(this1_).parent().parent().find("img").remove();
                                            jQuery(this1_).parent().parent().prepend("<img class='img"+attributeId+"' style='width: 90%;height: auto;margin:0 auto;display:block;' src='"+this_.$isHttp(ret.data.url)+"' />")
                                            jQuery('.attributeInfoImg'+attributeId).hide();
                                            var setNull = null;
                                            jQuery('.img'+attributeId).hover(function(){
                                                if(setNull != null){
                                                   clearTimeout(setNull);
                                                }
                                                jQuery('.attributeInfoImg'+attributeId).show();
                                            },function(){
                                                setNull = setTimeout(function(){
                                                    jQuery('.attributeInfoImg'+attributeId).hide();
                                                },1000);
                                            });
                                            jQuery('.img'+attributeId).parent().find(".attributeInfoImg").hover(function(){
                                                clearTimeout(setNull);
                                            },function(){
                                                setNull = setTimeout(function(){
                                                    jQuery('.attributeInfoImg'+attributeId).hide();
                                                },1000);
                                            },1000);
                                        }
                                    }
                                };
                                xhr.send(fd);
                            });
                        },1000);
                    }else if(attributeInfo.inputType == 7){ //多行输入类型

                        let htm = "";
                        let limitCondition = {minNumber:null,maxNumber:400};
                        if(attributeInfo.limitCondition != null && attributeInfo.limitCondition != ""){
                            limitCondition = JSON.parse(attributeInfo.limitCondition);
                            if(limitCondition.minNumber == 0){
                                limitCondition.minNumber = null;
                            }
                            if(limitCondition.maxNumber == 0){
                                limitCondition.maxNumber = 400;
                            }
                        }
                        if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                            htm = "<textarea class='attrEditInfo7 textareaClass' minlength='"+limitCondition.minNumber+"' maxlength='"+limitCondition.maxNumber+"' notNullStatus='"+attributeInfo.notNullStatus+"' title='请输入"+attributeName+"' placeholder='"+(attributeInfo.desc || "请输入"+attributeName)+"，只能输入400字' name='"+attributeInfo.attributeId+"'>"+attributeInfo.attributeRelation.value+"</textarea>";
                        }else{
                            htm = "<textarea class='attrEditInfo7 textareaClass' minlength='"+limitCondition.minNumber+"' maxlength='"+limitCondition.maxNumber+"' notNullStatus='"+attributeInfo.notNullStatus+"' title='请输入"+attributeName+"' placeholder='"+(attributeInfo.desc || "请输入"+attributeName)+"，只能输入400字' name='"+attributeInfo.attributeId+"'></textarea>";
                        }
                        this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                    }else if(attributeInfo.inputType == 8){ //日期类型
                        let htm = "";
                        if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                            htm = "<input readonly class='attrEditInfo8 dataClassInfo' notNullStatus='"+attributeInfo.notNullStatus+"' title='请选择"+attributeName+"' placeholder='"+(attributeInfo.desc || "请选择"+attributeName)+"' id='test"+attributeInfo.attributeId+"' name='"+attributeInfo.attributeId+"' value='"+attributeInfo.attributeRelation.value+"' />";
                        }else{
                            htm = "<input readonly class='attrEditInfo8 dataClassInfo' notNullStatus='"+attributeInfo.notNullStatus+"' title='请选择"+attributeName+"' placeholder='"+(attributeInfo.desc || "请选择"+attributeName)+"' id='test"+attributeInfo.attributeId+"' name='"+attributeInfo.attributeId+"' />";
                        }
                        this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);

                        setTimeout(function(){
                            jQuery("#test"+attributeInfo.attributeId).datetime({
                                type:"date",
                                success:function(res){
                                    console.log(res)
                                }
                            });

                        },1000);
                    }else if(attributeInfo.inputType == 9){ //签名
                        let htm = "";
                        if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                            htm = "<span id='attributeId"+attributeInfo.attributeId+"' notNullStatus='"+attributeInfo.notNullStatus+"'>"+attributeInfo.attributeRelation.value+"</span>";
                        }else{
                            htm = "<span id='attributeId"+attributeInfo.attributeId+"' notNullStatus='"+attributeInfo.notNullStatus+"'></span>";
                        }
                        this.signList.push({
                            attributeId:attributeInfo.attributeId
                        });
                        this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                    }
            }



            }
        },
        /**
         * @param {Object} valList //需要遍历的list
         * @param {Object} onValue 选中值 |||隔开
         * @param {Object} attributeId //最外层 属性ID
         * @param {Object} htm 拼接好的html
         * @param {Object} key 显示的位置
         * @param {Object} count 遍历的次数 可用于当前点击的第几个select
         */
        getErgodicInfo(valList,onValue,attributeId,htm,key,count = 0){
            let htmOn = "<option value='"+count+'_'+"'>请选择</option>",i = 0;
            if(!this.$isEmpty(onValue)){ //不为空时 需要返现
                for(let inx in valList){
                    if(!this.$isEmpty(onValue) && ("|||"+onValue+"|||").indexOf("|||"+valList[inx].attributeName+"|||") >= 0){
                        i = inx;
                        htmOn += "<option selected value='"+count+'_'+inx+"'>"+valList[inx].attributeName+"</option>";
                    }else{
                        htmOn += "<option value='"+count+'_'+inx+"'>"+valList[inx].attributeName+"</option>";
                    }
                }
            }else{
                if(this.$isEmpty(htm)){
                    for(let inx in valList){
                        htmOn += "<option value='"+count+'_'+inx+"'>"+valList[inx].attributeName+"</option>";
                    }
                }
            }
            htm += "<div class='select'><select class='attrEditInfo4 selectInput4' index='"+count+"' name='"+attributeId+"'>"+htmOn+"</select></div>";
            if(!this.$isEmpty(valList[i].children) && valList[i].children.length > 0){
                count ++;
                this.getErgodicInfo(valList[i].children,onValue,attributeId,htm,key,count);
            }else{
                this.htmlInfo = this.htmlInfo.replace(key,htm); //替换html


                //选择下拉联动
                setTimeout(()=>{ //绑定事件
                    let this_ = this;
                    jQuery("select[name='"+attributeId+"']").change(function(){
                        let positionVal = jQuery(this).val().split("_"); //拿到位置值0_1 0表示列数，1表示第几行
                        let idInfo = jQuery(this).attr("name");//拿到属性ID，根据属性ID获取list数据
                        let allList = this_.allInputType4[idInfo];
                        jQuery("select[name='"+idInfo+"']").each(function(n,k){ //所有的该ID关联select
                            if(positionVal[1] == null || positionVal[1] == ""){
                                jQuery("select[name='"+idInfo+"']:eq("+(n+1)+")").html("<option value='"+(n+1)+'_'+"'>请选择</option>");
                            }else{
                                let l = jQuery(this).val().split("_"); //位置信息
                                allList = allList[l[1]].children; //拿到最后哦一个值
                                if(n == Number(positionVal[0])){
                                    let htmLast = "<option value='"+(n+1)+'_'+"'>请选择</option>";
                                    for(let inx in allList){
                                        htmLast += "<option value='"+(n+1)+'_'+inx+"'>"+allList[inx].attributeName+"</option>";
                                    }
                                    jQuery("select[name='"+idInfo+"']:eq("+(n+1)+")").html(htmLast);
                                    return false;
                                }
                            }
                        });
                    });
                    jQuery("select[name='"+attributeId+"']:last").unbind(); //取消最后一个的联动
                },200);
            }
        },
        // 检查tr行中是否有值为"无"
        checkTrHasNoValue(element){
            // 找到元素所在的tr
            let $tr = jQuery(element).closest('tr');
            if($tr.length == 0 || !$tr.hasClass('isNotNull')){
                return false; // 不是isNotNull的行，返回false
            }

            // 检查该行中所有输入框、选择框、文本域的值
            let hasNoValue = false;

            // 检查select
            $tr.find('select').each(function(){
                let val = jQuery(this).val();
                if(val == '无' || val == '无'){
                    hasNoValue = true;
                    return false; // 跳出循环
                }
            });

            if(hasNoValue) return true;

            // 检查input
            $tr.find('input[type="text"], input:not([type])').each(function(){
                let val = jQuery(this).val();
                if(val == '无' || val == '无'){
                    hasNoValue = true;
                    return false;
                }
            });

            if(hasNoValue) return true;

            // 检查textarea
            $tr.find('textarea').each(function(){
                let val = jQuery(this).val();
                if(val == '无' || val == '无'){
                    hasNoValue = true;
                    return false;
                }
            });

            return hasNoValue;
        },
        // 检查弹窗表单数据中是否有值为"无"（用于弹窗模式）
        checkDialogFormHasNoValue(){
            // 遍历表单数据，检查是否有值为"无"
            for(let key in this.editFormData){
                let value = this.editFormData[key];
                // 处理字符串类型
                if(typeof value === 'string' && (value == '无' || value == '无')){
                    return true;
                }
                // 处理数组类型（多选）
                if(Array.isArray(value) && (value.includes('无') || value.includes('无'))){
                    return true;
                }
            }
            return false;
        },
        saveInfo(){ //保存模板数据
            let param;
            // 如果是从弹窗保存，使用弹窗的数据获取方法
            if(this.visible_editDialog || this.$strExistHostnameOnce(['hevttc','localhost1'])){
                param = this.getParamInfoForDialog();
            }else{
                param = this.getParamInfo();
            }
            if(param ==false){ //存在未填写的值
              return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/saveEditTemplateData",param).then((ret) => {
                loading.close();
                if(ret.code == 0){
                    this.$message.success(ret.msg);
                    if(this.visible_editDialog){
                        this.visible_editDialog = false;
                        this.getInfo();
                    }
                }else{
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
                loading.close();
            });
        },
        getParamInfo(){ //获取各种类型的参数信息
            let attributeRelationList = [];//{attributeIds:"属性ID",value:"学生填写的值多选（,）联动|||"}
            let isNot = true; //
            for(let item in this.getParamKey){
                let v = "";
                if(this.getParamKey[item] == 1){ //1单选 2多选 3输入 4多级联动  5上传图片 6上传附件 7多行输入 8日期
                    v = jQuery("select[name='"+item+"']").val();
                    // 检查是否在isNotNull的tr中且该行有"无"值
                    let skipValidation = this.checkTrHasNoValue(jQuery("select[name='"+item+"']"));
                    if(this.$isEmpty(v) && jQuery("select[name='"+item+"']").attr('notNullStatus') == 1 && !skipValidation){ //不能为空
                        this.$message.warning(jQuery("select[name='"+item+"']").attr('title'));
                        isNot = false;
                        break;
                    }
                }else if(this.getParamKey[item] == 2){
                    jQuery("input[name='"+item+"']:checked").each(function(i){
                        v += jQuery(this).val();
                        if(i < jQuery("input[name='"+item+"']:checked").length - 1){
                            v += ",";
                        }
                    });
                    // 检查是否在isNotNull的tr中且该行有"无"值
                    let skipValidation = this.checkTrHasNoValue(jQuery("input[name='"+item+"']"));
                    if(this.$isEmpty(v) && jQuery("input[name='"+item+"']").attr('notNullStatus') == 1 && !skipValidation){ //不能为空
                        this.$message.warning(jQuery("input[name='"+item+"']").attr('title'));
                        isNot = false;
                        break;
                    }
                }else if(this.getParamKey[item] == 3){
                    v = jQuery("input[name='"+item+"']").val();
                    // 检查是否在isNotNull的tr中且该行有"无"值
                    let skipValidation = this.checkTrHasNoValue(jQuery("input[name='"+item+"']"));
                    if(this.$isEmpty(v) && jQuery("input[name='"+item+"']").attr('notNullStatus') == 1 && !skipValidation){ //不能为空
                        this.$message.warning(jQuery("input[name='"+item+"']").attr('title'));
                        isNot = false;
                        break;
                    }
                    var minlength = jQuery("input[name='"+item+"']").attr('minlength');
                    if(!this.$isEmpty(minlength) && minlength > v.length && !skipValidation){
                        this.$message.warning(jQuery("input[name='"+item+"']").attr('title').replace("请输入","") +"最少输入"+minlength+"字");
                        isNot = false;
                        break;
                    }
                }else if(this.getParamKey[item] == 4){
                    jQuery("select[name='"+item+"']").each(function(i){
                        v += jQuery(this).find("option:selected").text();
                        if(i < jQuery("select[name='"+item+"']").length - 1){
                            v += "|||";
                        }
                    });
                }else if(this.getParamKey[item] == 5){
                    v = jQuery("input[name='"+item+"']").val();
                }else if(this.getParamKey[item] == 7){
                    v = jQuery("textarea[name='"+item+"']").val();
                    // 检查是否在isNotNull的tr中且该行有"无"值
                    let skipValidation = this.checkTrHasNoValue(jQuery("textarea[name='"+item+"']"));
                    if(this.$isEmpty(v) && jQuery("textarea[name='"+item+"']").attr('notNullStatus') == 1 && !skipValidation){ //不能为空
                        this.$message.warning(jQuery("textarea[name='"+item+"']").attr('title'));
                        isNot = false;
                        break;
                    }
                    var minlength = jQuery("textarea[name='"+item+"']").attr('minlength');
                    if(!this.$isEmpty(minlength) && minlength > v.length && !skipValidation){
                        this.$message.warning(jQuery("textarea[name='"+item+"']").attr('title').replace("请输入","") +"最少输入"+minlength+"字");
                        isNot = false;
                        break;
                    }
                }else if(this.getParamKey[item] == 8){
                    v = jQuery("input[name='"+item+"']").val();
                    // 检查是否在isNotNull的tr中且该行有"无"值
                    let skipValidation = this.checkTrHasNoValue(jQuery("input[name='"+item+"']"));
                    if(this.$isEmpty(v) && jQuery("input[name='"+item+"']").attr('notNullStatus') == 1 && !skipValidation){ //不能为空
                        this.$message.warning(jQuery("input[name='"+item+"']").attr('title'));
                        isNot = false;
                        break;
                    }
                }else if(this.getParamKey[item] == 9){
                    v = jQuery("#attributeId"+item).html();
                    // 检查是否在isNotNull的tr中且该行有"无"值
                    let skipValidation = this.checkTrHasNoValue(jQuery("#attributeId"+item));
                    if(this.$isEmpty(v) && jQuery("#attributeId"+item).attr('notNullStatus') == 1 && !skipValidation){ //不能为空
                        this.$message.warning("签名不能为空！");
                        isNot = false;
                        break;
                    }
                }

                attributeRelationList.push({attributeIds:item,value:v || ""});
                // if(!this.$isEmpty(v)){
                //     attributeRelationList.push({attributeIds:item,value:v});
                // }
            }
            if(isNot){
                return {
                    attributeRelationList:attributeRelationList,
                    templateId:this.templateId
                };
            }else{
                return isNot;
            }
        },
        getInfo(){ //获取table类型
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/useTableTemplate",{templateName:this.templateName}).then((ret) => {
                loading.close();
                if(ret.code == 0){
                    this.currentType = 1;
                    this.dataInfo = ret.studentTemplate;
                    if(ret.data.length > 0){
                        this.htmlInfo = ret.data[0];
                    }else{
                        this.$message({message: "生成失败！",type:"warning"});
                    }
                }else{
                  this.$message({message: ret.msg,type: "warning"});
                }
            }).catch((err) => {
                loading.close();
            });
        },
        printNow() { // 转图片打印
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            html2canvas(this.$refs.printContent,{
                allowTaint: false,
                useCORS: true,
                height: this.$refs.printContent.outerHeight,
                width: this.$refs.printContent.outerWidth,
                windowWidth: document.body.scrollWidth,
                windowHeight: document.body.scrollHeight,
            }).then((canvas) => {
                loading.close();
                // let url = canvas.toDataURL('image/jpeg', 1.0)
                const url = canvas.toDataURL();
                // const style = '@page {margin:0 10mm};'//打印时去掉眉页眉尾
                printJS({
                  printable: url,
                  type: 'image',
                  header: '',
                  style: `@media print { @page {size: auto;} body{margin:0}}`,
                  documentTitle: this.templateName || '我的信息打印',
                  targetStyles: ['*'],
                  // style
                });
            }).catch((err) => {
                loading.close();
            });
        },
        printNowImg(){ //打印图片类型
            //打印为什么要去掉眉页眉尾？因为眉页title时打印当前页面的title，相当于是获取html中title标签里面的内容，但是比如我打印的内容只是一个弹框里面的内容，是没有title的，这时候就会出现undefined，为了避免出现这种情况，就可以隐藏眉页眉尾
            // printJS({
            //     printable: this.$isHttp(this.imgUrlList[0]),// 标签元素id
            //     type: 'image',
            //     header: null,
            //     targetStyles: ['*'],
            //     style
            // });
            //判断图片是横屏还是竖屏，动态设置宽高，进行打印
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            var img = new Image();
            img.src = this.$isHttp(this.imgUrlList[0]);
            img.onload = ()=> {
                var realWidth = img.width;  // 真实宽度
                var realHeight = img.height; // 真实高度
                var outerHTML = ""; // 内容
                var style =  '@media print { @page {size: auto; margin: 0; } body{margin:0 0}}'//打印时去掉眉页眉尾
                if (realWidth > realHeight){ //横屏
                    style = '@media print { @page {size: landscape; margin: 0; } body{margin:0 0}}'//打印时去掉眉页眉尾
                    for(let i = 0;i<this.imgUrlList.length;i++){
                        outerHTML += '<div style="text-align: center;display: flex;justify-content: center;align-items: center;height:794px;"><img src="'+this.$isHttp(this.imgUrlList[i])+'" style="max-width: 100%;max-height:794px; display: inline-block;"/></div>'
                    }
                }else{ //竖屏
                    style = '@media print { @page {size: portrait; margin: 0; } body{margin:0 0}}'//打印时去掉眉页眉尾
                    for(let i = 0;i<this.imgUrlList.length;i++){
                        outerHTML += '<div style="text-align: center;display: flex;justify-content: center;align-items: center;height:1123px;"><img src="'+this.$isHttp(this.imgUrlList[i])+'" style="max-width: 100%;max-height:1123px; display: inline-block;"/></div>'
                    }
                }
                loading.close();
                printJS({
                    printable: outerHTML,// 标签元素id
                    type: 'raw-html',
                    header: null,
                    targetStyles: ['*'],
                    style
                });
            };

        },
        downImg(){ //导出IMG
            // this.$downLoadFile(this.imgUrlList[0]);
            this.$downLoadFile(this.downloadUrl);
        },
        downloadNow(){ //导出
            if(!this.$isEmpty(this.studentInfo.studentId)){
                this.$downLoadFile("/api/student/exportTableTemplateToPdf.do?templateName="+this.templateName+"&studentId="+this.studentInfo.studentId,this.studentInfo.studentName+"__"+this.templateName+".zip");
            }else{
                this.$message.warning("学生数据丢失！");
            }
        },
        getTemplateByName(){ //获取模板信息
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getTemplateByName",{templateName:this.templateName}).then((ret) => {
                loading.close();
                if(ret.code == 0){
                    this.templateType = ret.data.templateType;
                    if(this.templateType == 2){
                        this.getInfo();
                    }else if(this.templateType == 1){
                        this.getUseImgTemplate();
                    }
                    if(ret.data.type == 2){
                        this.isEdit = true;
                    }
                }else{
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
                loading.close();
            });
        },
        getUseImgTemplate() { //获取图片类型
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/useImgTemplate", {templateName: this.templateName}).then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.imgUrlList = ret.data || [];
                    this.downloadUrl = ret.downloadUrl || "";
                } else {
                    this.$message({message: ret.msg, type: "warning"});
                }
            }).catch(err=>{
                loading.close();

            })
        },
        seeRemark(){ //查看备注
            this.$notify.error({
              title: '审核未通过原因',
              position: 'bottom-right',
              duration:60000,
              message: this.dataInfo.studentTemplateExamineRemark
            });
        },
        singShow(item){
            // 保存当前签名的attributeId，避免被其他操作覆盖
            this.onAttributeId = item.attributeId || item;
            this.visible = true;
        },
        signStart(){ //本人签名
            this.visible = false;
            // 确保在打开签名对话框时，onAttributeId已经正确设置
            this.visible_sign = true;
        },
        closeMsg(){
            this.visible_sign = false;
        },
        saveSignValue(data, attributeId){ //签名的url地址
            // 优先使用传递过来的attributeId，如果没有则使用onAttributeId
            // 确保attributeId不为空
            let targetAttributeId = attributeId;
            if(this.$isEmpty(targetAttributeId)){
                targetAttributeId = this.onAttributeId;
            }
            // 再次检查，确保有有效的attributeId
            if(this.$isEmpty(targetAttributeId)){
                console.error('签名保存失败：缺少attributeId');
                this.$message.error('签名保存失败：缺少属性ID');
                return;
            }
            let signHtml = '<img style="width: 200px;height: 100px;" src="'+this.$isHttp(data)+'">';
            if(this.visible_editDialog){
                // 弹窗模式：使用具体的attributeId保存到对应的字段
                this.$set(this.editFormData, 'attr_' + targetAttributeId, signHtml);
                console.log('签名保存成功，attributeId:', targetAttributeId);
            }else{
                // 原模式
                jquery("#attributeId"+targetAttributeId).html(signHtml);
            }
        },
        creatQRCode(){
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let urlParm = window.configs.API_ROOT;//.replace("http","xxxx").replace("//","a_a").replace(/:/g,"axa").replace("/","c_c");
            const url = "http://ggk.cj-edu.com/h5/pages/studentInfo/userInfoScanCode?attributeId="+this.onAttributeId+"&tInfo="+getCookieForRoleTag()+"&url="+urlParm+"&templateId="+this.templateId;//window.configs.API_ROOT
            this.$store.dispatch("user/creatQRCode", {data: url}).then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.qRcodeImg = this.$isHttp(ret.data);
                    this.visible = false;
                    this.visible_qRcode = true;
                } else {
                    this.$message({message: ret.msg, type: "warning"});
                }
            }).catch(err=>{
                loading.close();

            })
        },
        getSignInfo(){ //手动获取手机端是否已经签名
            this.signLoading = true;
            this.$store.dispatch("user/getAttributeRelation", {attributeId:this.onAttributeId,typeId:this.studentInfo.studentId}).then((ret) => {
                this.signLoading = false;
                if (ret.code == 0) {
                    if(ret.data != null && ret.data != '' && ret.data.value != null && ret.data.value != ""){
                        if(this.visible_editDialog){
                            // 弹窗模式
                            this.$set(this.editFormData, 'attr_' + this.onAttributeId, ret.data.value);
                        }else{
                            // 原模式
                        jQuery("#attributeId"+this.onAttributeId).html(ret.data.value);
                        }
                        this.visible_qRcode = false;
                        this.$message({message: '签名成功！', type: "success"});
                    }else{
                        this.$message({message: '未获取到签名，请扫码进行签名！', type: "warning"});
                    }
                } else {
                    this.$message({message: ret.msg, type: "warning"});
                }
            }).catch(err=>{
                this.signLoading = false;
            })

        },
        // 初始化弹窗表单数据
        initEditFormData(){
            this.editFormData = {};
            this.getParamKey = {};
            this.fileListMap = {}; // 重置文件列表缓存
            for(let i in this.openAttributeInfoList){
                let item = this.openAttributeInfoList[i];
                if(this.$isEmpty(item)){
                    continue;
                }
                this.getParamKey[item.attributeId] = item.inputType;
                let defaultValue = "";
                if(!this.$isEmpty(item.attributeRelation) && !this.$isEmpty(item.attributeRelation.value)){
                    defaultValue = item.attributeRelation.value;
                }
                let key = 'attr_' + item.attributeId;
                if(item.inputType == 2){
                    // 多选，需要转换为数组
                    if(!this.$isEmpty(defaultValue)){
                        this.$set(this.editFormData, key, defaultValue.split(','));
                    }else{
                        this.$set(this.editFormData, key, []);
                    }
                }else{
                    this.$set(this.editFormData, key, defaultValue);
                }
                // 如果是附件上传类型，初始化文件列表缓存
                if(item.inputType == 6 && !this.$isEmpty(defaultValue)){
                    this.$set(this.fileListMap, item.attributeId, [{
                        name: defaultValue.split('/').pop(),
                        url: this.$isHttp(defaultValue)
                    }]);
                }
            }
        },
        // 对话框打开后的回调
        handleDialogOpened(){
            // 对话框打开后，确保表单数据已正确初始化
            this.$nextTick(() => {
                // 重新初始化表单数据，确保响应式
                for(let i in this.openAttributeInfoList){
                    let item = this.openAttributeInfoList[i];
                    if(this.$isEmpty(item)){
                        continue;
                    }
                    let key = 'attr_' + item.attributeId;
                    // 如果属性不存在，使用$set添加
                    if(!this.editFormData.hasOwnProperty(key)){
                        if(item.inputType == 2){
                            this.$set(this.editFormData, key, []);
                        }else{
                            this.$set(this.editFormData, key, "");
                        }
                    }
                    // 加载所有多级联动数据
                    if(item && item.inputType == 4){
                        this.loadCascadeData(item);
                    }
                }
                // 清除表单验证状态
                if(this.$refs.editForm){
                    this.$refs.editForm.clearValidate();
                }
            });
        },
        // 获取属性值列表
        getAttributeValues(item){
            if(this.$isEmpty(item.attributeValues)){
                return [];
            }
            return item.attributeValues.replace(/\r/g,"").split("\n").filter(v => v);
        },
        // 获取限制条件
        getLimitCondition(item){
            let limitCondition = {minNumber:null, maxNumber:null};
            if(item.limitCondition != null && item.limitCondition != ""){
                try{
                    limitCondition = JSON.parse(item.limitCondition);
                    if(limitCondition.minNumber == 0){
                        limitCondition.minNumber = null;
                    }
                    if(limitCondition.maxNumber == 0){
                        limitCondition.maxNumber = null;
                    }
                }catch(e){
                    console.error("解析limitCondition失败", e);
                }
            }
            if(item.inputType == 7 && !limitCondition.maxNumber){
                limitCondition.maxNumber = 400;
            }
            return limitCondition;
        },
        // 获取表单验证规则
        getFormRules(item){
            let rules = [];
            if(item.notNullStatus == 1){
                rules.push({
                    required: true,
                    message: '请输入' + item.attributeName,
                    trigger: item.inputType == 2 ? 'change' : 'blur'
                });
            }
            if(item.inputType == 3 || item.inputType == 7){
                let limitCondition = this.getLimitCondition(item);
                if(limitCondition.minNumber){
                    rules.push({
                        min: limitCondition.minNumber,
                        message: '最少输入' + limitCondition.minNumber + '字',
                        trigger: 'blur'
                    });
                }
            }
            return rules;
        },
        // 获取上传请求头
        getUploadHeaders(){
            return {
                token: this.$getCookieForRoleTag()
            };
        },
        // 上传前验证
        beforeAvatarUpload(file){
            const isLt5M = file.size / 1024 / 1024 < 500;
            if (!isLt5M) {
                this.$message.error('上传文件大小不能超过 500MB!');
            }
            return isLt5M;
        },
        // 上传成功回调
        handleUploadSuccess(res, file, attributeId){
            if(res.code == 0){
                this.$set(this.editFormData, 'attr_' + attributeId, res.data.url);
                // 更新文件列表缓存
                this.$set(this.fileListMap, attributeId, [{
                    name: res.data.nameFormat || res.data.url.split('/').pop(),
                    url: this.$isHttp(res.data.url)
                }]);
                this.$message.success('上传成功！');
            }else{
                this.$message.error(res.msg);
            }
        },
        // 处理文件删除
        handleFileRemove(attributeId, file, fileList){
            // 更新文件列表
            this.$set(this.fileListMap, attributeId, fileList || []);
            // 如果文件列表为空，清空对应的数据
            if(this.$isEmpty(fileList) || fileList.length == 0){
                this.$set(this.editFormData, 'attr_' + attributeId, '');
            }
        },
        // 加载多级联动数据
        loadCascadeData(item){
            this.$store.dispatch("user/getAttrTreeById",{attributeId:item.attributeId}).then((ret) => {
                if(ret.code == 0){
                    this.allInputType4[item.attributeId] = ret.data.children;
                    this.$nextTick(() => {
                        this.renderCascadeSelect(item);
                    });
                }else{
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
                console.error("加载多级联动数据失败", err);
            });
        },
        // 渲染多级联动选择器
        renderCascadeSelect(item){
            let container = jQuery('#cascade_' + item.attributeId);
            if(container.length == 0){
                return;
            }
            let relationVal = this.editFormData['attr_' + item.attributeId] || "";
            let children = this.allInputType4[item.attributeId] || [];
            let htm = this.getErgodicInfoForDialog(children, relationVal, item.attributeId, "", 0);
            container.html(htm);
            // 绑定事件
            this.$nextTick(() => {
                this.bindCascadeEvents(item.attributeId);
            });
        },
        // 为弹窗生成多级联动HTML
        getErgodicInfoForDialog(valList, onValue, attributeId, htm, count = 0){
            if(this.$isEmpty(valList) || valList.length == 0){
                return htm;
            }
            let htmOn = "<option value=''>请选择</option>";
            let selectedIndex = 0;
            if(!this.$isEmpty(onValue)){
                let values = onValue.split("|||");
                for(let inx in valList){
                    if(values[count] == valList[inx].attributeName){
                        selectedIndex = inx;
                        htmOn += "<option selected value='"+count+'_'+inx+"'>"+valList[inx].attributeName+"</option>";
                    }else{
                        htmOn += "<option value='"+count+'_'+inx+"'>"+valList[inx].attributeName+"</option>";
                    }
                }
            }else{
                for(let inx in valList){
                    htmOn += "<option value='"+count+'_'+inx+"'>"+valList[inx].attributeName+"</option>";
                }
            }
            htm += "<div class='select' style='margin-bottom: 10px;'><select class='attrEditInfo4 selectInput4' index='"+count+"' name='"+attributeId+"'>"+htmOn+"</select></div>";
            if(!this.$isEmpty(onValue) && !this.$isEmpty(valList[selectedIndex]) && !this.$isEmpty(valList[selectedIndex].children) && valList[selectedIndex].children.length > 0){
                count++;
                htm = this.getErgodicInfoForDialog(valList[selectedIndex].children, onValue, attributeId, htm, count);
            }
            return htm;
        },
        // 绑定多级联动事件
        bindCascadeEvents(attributeId){
            let this_ = this;
            jQuery("select[name='"+attributeId+"']").off('change').on('change', function(){
                let positionVal = jQuery(this).val().split("_");
                let idInfo = jQuery(this).attr("name");
                let allList = this_.allInputType4[idInfo];
                let currentIndex = Number(jQuery(this).attr("index"));
                // 清除后续的select
                jQuery("select[name='"+idInfo+"']").each(function(){
                    if(Number(jQuery(this).attr("index")) > currentIndex){
                        jQuery(this).parent().remove();
                    }
                });
                if(positionVal[1] != null && positionVal[1] != ""){
                    // 根据选择的路径找到对应的子节点
                    let selectedItem = allList;
                    let path = [];
                    // 先收集所有已选择的路径
                    jQuery("select[name='"+idInfo+"']").each(function(){
                        let val = jQuery(this).val();
                        if(val && val != ""){
                            let pos = val.split("_");
                            if(pos[1] != null && pos[1] != ""){
                                path.push(Number(pos[1]));
                            }
                        }
                    });
                    // 根据路径找到当前选中的节点
                    for(let i = 0; i < path.length; i++){
                        if(i < path.length - 1){
                            selectedItem = selectedItem[path[i]].children;
                        }else{
                            selectedItem = selectedItem[path[i]];
                        }
                    }
                    if(!this_.$isEmpty(selectedItem) && !this_.$isEmpty(selectedItem.children) && selectedItem.children.length > 0){
                        let nextCount = currentIndex + 1;
                        let nextHtm = this_.getErgodicInfoForDialog(selectedItem.children, "", idInfo, "", nextCount);
                        jQuery(this).parent().after(nextHtm);
                        this_.$nextTick(() => {
                            this_.bindCascadeEvents(idInfo);
                        });
                    }
                }
            });
        },
        // 弹窗确定按钮
        handleEditDialogConfirm(){
            this.$refs.editForm.validate((valid) => {
                if(valid){
                    this.saveInfo();
                }else{
                    this.$message.warning('请填写完整信息');
                }
            });
        },
        // 修改getParamInfo方法，支持从弹窗获取数据
        getParamInfoForDialog(){
            let attributeRelationList = [];
            let isNot = true;
            // 检查弹窗表单中是否有"无"值（用于跳过必填验证）
            let skipValidation = this.checkDialogFormHasNoValue();

            for(let item in this.getParamKey){
                let v = "";
                let attributeId = item;
                let inputType = this.getParamKey[item];
                let formKey = 'attr_' + attributeId;
                let formValue = this.editFormData[formKey];
                if(inputType == 1){ //单选
                    v = formValue || "";
                    let itemInfo = this.openAttributeInfoList.find(attr => attr.attributeId == attributeId);
                    if(this.$isEmpty(v) && itemInfo && itemInfo.notNullStatus == 1 && !skipValidation){
                        this.$message.warning('请选择' + (itemInfo.attributeName || ''));
                        isNot = false;
                        break;
                    }
                }else if(inputType == 2){ //多选
                    if(Array.isArray(formValue)){
                        v = formValue.join(',');
                    }else{
                        v = formValue || "";
                    }
                    let itemInfo = this.openAttributeInfoList.find(attr => attr.attributeId == attributeId);
                    if(this.$isEmpty(v) && itemInfo && itemInfo.notNullStatus == 1 && !skipValidation){
                        this.$message.warning('请选择' + (itemInfo.attributeName || ''));
                        isNot = false;
                        break;
                    }
                }else if(inputType == 3){ //输入
                    v = formValue || "";
                    let itemInfo = this.openAttributeInfoList.find(attr => attr.attributeId == attributeId);
                    if(this.$isEmpty(v) && itemInfo && itemInfo.notNullStatus == 1 && !skipValidation){
                        this.$message.warning('请输入' + (itemInfo.attributeName || ''));
                        isNot = false;
                        break;
                    }
                    let limitCondition = this.getLimitCondition(itemInfo);
                    if(!this.$isEmpty(limitCondition.minNumber) && v.length < limitCondition.minNumber && !skipValidation){
                        this.$message.warning((itemInfo.attributeName || '') + '最少输入' + limitCondition.minNumber + '字');
                        isNot = false;
                        break;
                    }
                }else if(inputType == 4){ //多级联动
                    let selects = jQuery("select[name='"+attributeId+"']");
                    selects.each(function(i){
                        let text = jQuery(this).find("option:selected").text();
                        if(text && text != '请选择'){
                            v += text;
                            if(i < selects.length - 1){
                                v += "|||";
                            }
                        }
                    });
                }else if(inputType == 5 || inputType == 6){ //上传图片或附件
                    v = formValue || "";
                }else if(inputType == 7){ //多行输入
                    v = formValue || "";
                    let itemInfo = this.openAttributeInfoList.find(attr => attr.attributeId == attributeId);
                    if(this.$isEmpty(v) && itemInfo && itemInfo.notNullStatus == 1 && !skipValidation){
                        this.$message.warning('请输入' + (itemInfo.attributeName || ''));
                        isNot = false;
                        break;
                    }
                    let limitCondition = this.getLimitCondition(itemInfo);
                    if(!this.$isEmpty(limitCondition.minNumber) && v.length < limitCondition.minNumber && !skipValidation){
                        this.$message.warning((itemInfo.attributeName || '') + '最少输入' + limitCondition.minNumber + '字');
                        isNot = false;
                        break;
                    }
                }else if(inputType == 8){ //日期
                    v = formValue || "";
                    let itemInfo = this.openAttributeInfoList.find(attr => attr.attributeId == attributeId);
                    if(this.$isEmpty(v) && itemInfo && itemInfo.notNullStatus == 1 && !skipValidation){
                        this.$message.warning('请选择' + (itemInfo.attributeName || ''));
                        isNot = false;
                        break;
                    }
                }else if(inputType == 9){ //签名
                    v = formValue || "";
                    let itemInfo = this.openAttributeInfoList.find(attr => attr.attributeId == attributeId);
                    if(this.$isEmpty(v) && itemInfo && itemInfo.notNullStatus == 1 && !skipValidation){
                        this.$message.warning("签名不能为空！");
                        isNot = false;
                        break;
                    }
                }
                attributeRelationList.push({attributeIds:attributeId, value:v || ""});
            }
            if(isNot){
                return {
                    attributeRelationList:attributeRelationList,
                    templateId:this.templateId
                };
            }else{
                return false;
            }
        }
    }
};
</script>
<style src="../static/date/dateTime.scss"></style>
<style lang="less">
    @import '../styles/base.less';
    .templateEdit{
        padding-top: 50px;
        .select {
            display: inline-block;
            width: 100%;
            position: relative;
            vertical-align: middle;
            padding: 0;
            overflow: hidden;
            background-color: #fff;
            color: #555;
            border: 1px solid #aaa;
            text-shadow: none;
            border-radius: 4px;
            transition: box-shadow 0.25s ease;
            z-index: 2;
        }

        .select:hover {
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
        }

        .select:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 10px solid transparent;
            border-top-color: #ccc;
            top: 14px;
            right: 10px;
            cursor: pointer;
            z-index: -2;
        }
        .select select {
            cursor: pointer;
            padding: 10px;
            width: 100%;
            border: none;
            background: transparent;
            background-image: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
        }
        .select select option{
            padding: 20px 100px !important;
            min-height: 50px;
            white-space: initial;
            font-size: 18px;
            border: none;
        }
        .select select:focus,.inputClass:focus,.textareaClass:focus,.dataClassInfo:focus {
            outline: none;
        }

        .inputClass{
            padding: 10px;
            border-radius: 5px;
            border: 1px solid #aaa;
            width: calc(100% - 20px);
        }

        .textareaClass {
            padding: 10px;
            border-radius: 5px;
            border: 1px solid #aaa;
            width: calc(100% - 20px);
            min-height: 200px;
        }

        .checkboxClass{
            margin-right: 10px;
            float: left;
        }
        .checkboxClass input{
            margin-right: 10px;
        }
        .checkboxClass input,.checkboxClass label{
            cursor: pointer;
        }
        .dataClassInfo{
            border: 1px solid #aaa;
            border-radius: 5px;
            width: calc(100% - 20px);
            padding: 10px;
        }

        #printBill{
            width: 1060px;
            table{
                width: 100% !important;
                tr{
                    page-break-inside: avoid; //避免打印被截断
                }
            }
        }
        .but{
            font-size: 18px;
            border-color:@bgZS;
            color:@bgZS;
            padding:8px 10px;
        }
        .avatar-input{
            display: none;
        }
        .lee-upload-fileicon{
            cursor: pointer;
            color:@bgZS;
            display: block;
            width: 80%;
            margin-left: 10%;
        }
        .attributeInfoImg{
            position: absolute;
            text-align: center;
            width: 100%;
            left: 0;
            top: calc(50% - 25px);
        }
        .attributeInfoImg:hover{
            .lee-upload-fileicon{
                border: 1px dotted @bgZS;
                width: calc(80% - 2px);
                height: 37px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/templateEdit.vue